import React from 'react';
import ReactDOM from 'react-dom';
import { EventsCollectionWithFetch } from './components/index.js'

/**
 * Support is needed for providing filters via url query string.
 * An example url might be `?languages=spanish&countries=chile&types=webinars
 */

const element = document.getElementById('events-collection')
if (element && element.dataset) {
    const {
        filterMenuEnabled,
        searchEnabled,
        selectedTaxonomies,
        columns = 3,
        rows = 3,
        sortByEnabled,
        sortByDefault,
        sortDirectionDefault,
        selectedSortOptions,
        loadMoreEnabled,
        upcomingOnlyEnabled,
        showOnlyFeatured,
        viewToggleEnabled
    } = JSON.parse(element.dataset.blockAttributes)

    console.log({ blockAttributes: JSON.parse(element.dataset.blockAttributes) })
    ReactDOM.render(
        <React.StrictMode>
            <EventsCollectionWithFetch
                searchControlEnabled={searchEnabled}
                searchControlPlaceholder='Enter keywords'
                searchControlLabel='Search Customer Stories'
                filterControlsEnabled={filterMenuEnabled}
                taxonomyFilters={selectedTaxonomies}
                postTypeFilterControlEnabled={false}
                columns={columns}
                rows={rows}
                selectedSortOptions={selectedSortOptions}
                sortByEnabled={sortByEnabled}
                loadMoreEnabled={loadMoreEnabled}
                upcomingOnlyEnabled={upcomingOnlyEnabled}
                showOnlyFeatured={showOnlyFeatured}
                viewToggleEnabled={viewToggleEnabled}
            />
        </React.StrictMode>,
        element
    );
}
